import moment from "moment";
import { ActionTree } from "vuex";

import i18n from "@/lang";

import { LicenseState } from "./state";
import { SET_ACTIVE_LICENSE } from "./mutations";

import { RootState } from "@/store";
import { ADD_ALERT } from "../AlertModule/mutations";
import { AlertModel, AlertModelType } from "../AlertModule/types";
import { GetLicenseDataCommand } from "@/model/communication/license/GetLicenseDataCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { LicenseModuleStatusEnum } from "@/model/data/License/LicenseModuleStatusEnum";
import { stretchingWindowAfterExpiration } from "@/model/data/License/LicenseModule";
import { getLicenseModuleLabel } from "@/model/data/License/LicenseModuleEnum";

export const FETCH_LICENSE = "FETCH_LICENSE";

export default {
    async [FETCH_LICENSE]({ commit }) {
        const res = await new GetLicenseDataCommand().execute();

        if (res.responseStatus == ApiResponseStatusEnum.Success) {
            commit(SET_ACTIVE_LICENSE, res.licenseData);

            // verifico lo stato delle licenze
            console.group("LICENSE STATUS");
            res.licenseData.modules.forEach((licenseData) => {
                console.log(`license mod=${licenseData.module}, nDev=${licenseData.nDevices}, status=${licenseData.status}`, licenseData);

                let showAlert = false;
                let alertType = AlertModelType.Info;
                let alertMessage = i18n.t(getLicenseModuleLabel(licenseData.module)).toString() + ": ";

                if (licenseData.nDevices) {
                    switch (licenseData.getStatus()) {
                        //
                        // se è vicina alla scadenza lancio un warning
                        //
                        case LicenseModuleStatusEnum.CloseToExpiration:
                            showAlert = true;
                            alertType = AlertModelType.Warning;
                            alertMessage += i18n.tc("license.license_will_expire_in_days", Math.abs(licenseData.getExpirationDateDiff()));

                            break;

                        //
                        // se scaduta di recente lancio un errore
                        //
                        case LicenseModuleStatusEnum.ExpiredRecently:
                            showAlert = true;
                            alertType = AlertModelType.Error;
                            alertMessage += `${i18n.t("license.license_is_expired")}. ${i18n.tc(
                                "license.you_can_still_use_clink_for_days",
                                stretchingWindowAfterExpiration - Math.abs(licenseData.getExpirationDateDiff())
                            )}`;

                            break;

                        //
                        // se è scaduta definitivamente lancio un errore
                        //
                        case LicenseModuleStatusEnum.Expired:
                            showAlert = true;
                            alertType = AlertModelType.Error;
                            alertMessage += i18n.t("license.license_is_expired").toString();

                            break;
                    }
                }

                if (showAlert) {
                    commit(ADD_ALERT, new AlertModel(alertType, alertMessage, null));
                }
            });

            console.groupEnd();
        }
    },
} as ActionTree<LicenseState, RootState>;
